import { useGetNoticeBannerQuery } from '../../../api/rtk-query/loungeBoardApi'
import { createPortal } from 'react-dom'
import { useBoolean, useLocalStorage } from 'usehooks-ts'
import { useCallback, useEffect } from 'react'
import { LOUNGE_BOARD_SERVICE_TYPE } from '../loungeBoardContants'

const LoungeBoardAlert = () => {
  const { data, isSuccess } = useGetNoticeBannerQuery(undefined, {
    selectFromResult: result => ({
      ...result,
      data: result.data?.data || {},
    }),
  })
  const [value, setValue] = useLocalStorage(
    'loungeBoardBannerExpireTime',
    undefined
  )
  const { value: visible, setFalse: close, setTrue: open } = useBoolean(false)

  const handleClose = useCallback(() => {
    const expireTime = new Date()
    expireTime.setHours(23, 59, 59, 0)
    setValue(expireTime.getTime())
    close()
  }, [close, setValue])

  useEffect(() => {
    const now = new Date()
    if (
      isSuccess &&
      data?.id &&
      (value === undefined || value < now.getTime())
    ) {
      open()
    }
  }, [isSuccess, data, open, value])
  return (
    visible &&
    createPortal(
      <div
        className="guide_msg3"
        style={{
          zIndex: 99999,
        }}>
        <a
          href={`${process.env.REACT_APP_LOUNGE_BOARD_HOST}/bulletin/${data.id}?serviceType=${LOUNGE_BOARD_SERVICE_TYPE}`}
          target="_blank"
          rel="noreferrer"
          onClick={close}
          style={{ textDecoration: 'none' }}>
          <p className="desc_msg" style={{ color: 'white' }}>
            {data.title}
          </p>
        </a>
        <a className="link_close" onClick={handleClose}>
          <span className="ico_comm ico_close">닫기</span>
        </a>
      </div>,
      document.body
    )
  )
}
export default LoungeBoardAlert
